import React, { useState, useRef, useEffect } from "react";
import { classNames } from "primereact/utils";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import axios from "axios";
import DashSideBar from "../../shared/DashSideBar";
import "./ProjectListContent.css";
import { Editor } from "primereact/editor";
import { Dropdown } from "primereact/dropdown";

function ProjectListContents() {
  let emptyProjectListContent = {
    id: null,
    name: "",
    description: "",
    sortOrder: null,
    project: { id: null, name: "" },
  };
  const [ProjectListContents, setProjectListContents] = useState(null);
  const [projects, setProjects] = useState(null);
  const [ProjectListContentsDialog, setProjectListContentsDialog] =
    useState(false);
  const [DeleteProjectListContent, setDeleteProjectListContent] =
    useState(false);
  const [DeleteProjectListContentsDialog, setDeleteProjectListContentsDialog] =
    useState(false);
  const [ProjectListContent, setProjectListContent] = useState(
    emptyProjectListContent
  );
  const [selectedProjectListContents, setSelectedProjectListContents] =
    useState(null);
  const [submitted, setSubmitted] = useState(false);
  const [globalFilter, setGlobalFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const dt = useRef(null);

  const isFetched = useRef(false);

  useEffect(() => {
    if (!isFetched.current) {
      getProjectListContents();
      getProjects();
      isFetched.current = true; // Ensure it only runs once
    }
  }, []);
  const getProjects = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL +
          "api/Projects/GetProjectsForProjectMaterials"
      );

      if (response.data) {
        setProjects(response.data);
      }
    } catch (error) {
      console.error("Error fetching projectVideos:", error);
    }
  };
  const getProjectListContents = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_BACKEND_URL + "api/Project_List_Content"
      );

      if (response.data) {
        setProjectListContents(response.data);
      }
    } catch (error) {
      console.error("Error fetching ProjectListContents:", error);
    }
  };

  const openNew = () => {
    setProjectListContent(emptyProjectListContent);
    setSubmitted(false);
    setProjectListContentsDialog(true);
  };

  const hideDialog = () => {
    setSubmitted(false);
    setProjectListContentsDialog(false);
  };

  const hideDeleteProductDialog = () => {
    setDeleteProjectListContent(false);
  };

  const hideDeleteProductsDialog = () => {
    setDeleteProjectListContentsDialog(false);
  };

  const saveService = async () => {
    setLoading(true);
    setSubmitted(true);

    try {
      if (ProjectListContent.name.trim()) {
        let _ProjectListContents = [...ProjectListContents];
        let _ProjectListContent = { ...ProjectListContent };

        if (ProjectListContent.id) {
          const index = findIndexById(ProjectListContent.id);

          let formData = new FormData();
          formData.append("Name", _ProjectListContent.name);
          formData.append("Description", _ProjectListContent.description);
          formData.append("sortOrder", _ProjectListContent.sortOrder);
          formData.append("projectId", _ProjectListContent.project.id);

          const response = await axios.put(
            process.env.REACT_APP_BACKEND_URL +
              "api/Project_List_Content/" +
              ProjectListContent.id,
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" }, // Fix Content-Type for FormData
            }
          );

          if (response.data) {
            _ProjectListContents[index] = _ProjectListContent;
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Our Project List Content Updated",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Our Project List Content Not Updated",
              life: 3000,
            });
          }
        } else {
          _ProjectListContent.id = createId();
          let formData = new FormData();
          formData.append("Name", _ProjectListContent.name);
          formData.append("Description", _ProjectListContent.description);
          formData.append("sortOrder", _ProjectListContent.sortOrder);
          formData.append("projectId", _ProjectListContent.project.id);

          const response = await axios.post(
            process.env.REACT_APP_BACKEND_URL + "api/Project_List_Content",
            formData,
            {
              headers: { "Content-Type": "multipart/form-data" }, // Fix Content-Type for FormData
            }
          );

          if (response.data) {
            _ProjectListContents.push(response.data.projectVideo);
            toast.current.show({
              severity: "success",
              summary: "Successful",
              detail: "Our Project List Content Added",
              life: 3000,
            });
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Our Project List Content Not Added",
              life: 3000,
            });
          }
        }

        setProjectListContents(_ProjectListContents);
        setProjectListContentsDialog(false);
        setProjectListContent(emptyProjectListContent);
      }
    } catch (error) {
      console.error("Error during save operation:", error);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail:
          "An error occurred while saving the service. Please try again later.",
        life: 3000,
      });
    } finally {
      setLoading(false);
    }
  };

  const editProduct = (ProjectListContent) => {
    setProjectListContent({ ...ProjectListContent });
    setProjectListContentsDialog(true);
  };

  const confirmDeleteProduct = (ProjectListContent) => {
    setProjectListContent(ProjectListContent);
    setDeleteProjectListContent(true);
  };
  const onProjectChange = (selectedOption) => {
    const selectedProjectId = selectedOption.value; // Assuming 'value' contains the selected category ID

    const selectedProject = projects.find(
      (project) => project.id === selectedProjectId
    );
    setProjectListContent({
      ...ProjectListContent,
      project: { id: selectedOption.value, name: selectedProject.name },
    });
  };

  const deleteProduct = async () => {
    setLoading(true);
    try {
      const response = await axios.delete(
        process.env.REACT_APP_BACKEND_URL +
          "api/Project_List_Content/" +
          ProjectListContent.id
      );

      setLoading(false);

      if (response.status === 204) {
        // ✅ Check response status instead of data
        let _ProjectListContents = ProjectListContents.filter(
          (val) => val.id !== ProjectListContent.id
        );
        setProjectListContents(_ProjectListContents);
        setDeleteProjectListContent(false);
        setProjectListContent(emptyProjectListContent);
        toast.current.show({
          severity: "success",
          summary: "Successful",
          detail: "Our Project List Content Deleted",
          life: 3000,
        });
      } else {
        throw new Error("Unexpected response");
      }
    } catch (error) {
      setLoading(false);
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our Project List Content Not Deleted",
        life: 3000,
      });
    }
  };

  const findIndexById = (id) => {
    let index = -1;

    for (let i = 0; i < ProjectListContents.length; i++) {
      if (ProjectListContents[i].id === id) {
        index = i;
        break;
      }
    }

    return index;
  };

  const createId = () => {
    let id = "";
    let chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (let i = 0; i < 5; i++) {
      id += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return id;
  };

  const exportCSV = () => {
    dt.current.exportCSV();
  };

  const confirmDeleteSelected = () => {
    setDeleteProjectListContentsDialog(true);
  };

  const deleteSelectedProducts = async () => {
    setLoading(true);
    const ids = selectedProjectListContents.map(
      (ProjectListContent) => ProjectListContent.id
    );
    const idsString = ids.join(",");
    let data = { Ids: idsString };
    const response = await axios.post(
      process.env.REACT_APP_BACKEND_URL +
        "api/Project_List_Content/DeleteProjectsListContentByIds",
      data
    );
    setLoading(false);
    if (response.data.success) {
      let _ProjectListContents = ProjectListContents.filter(
        (val) => !selectedProjectListContents.includes(val)
      );
      setProjectListContents(_ProjectListContents);
      setDeleteProjectListContentsDialog(false);
      setSelectedProjectListContents(null);
      toast.current.show({
        severity: "success",
        summary: "Successful",
        detail: "Our Project List Contents Deleted",
        life: 3000,
      });
    } else {
      toast.current.show({
        severity: "error",
        summary: "Error",
        detail: "Our Project List Contents Not Deleted",
        life: 3000,
      });
    }
  };

  const onInputChange = (e, name) => {
    const val = (e.target && e.target.value) || "";
    let _ProjectListContent = { ...ProjectListContent };

    _ProjectListContent[`${name}`] = val;

    setProjectListContent(_ProjectListContent);
  };
  const leftToolbarTemplate = () => {
    return (
      <div className="d-flex align-items-center justify-content-center gap-5">
        <h4 className="m-0 title-of-table">Manage Project List Content</h4>
        <span className="p-input-icon-left">
          <i className="pi pi-search" />
          <InputText
            type="search"
            style={{ border: "1px solid black" }}
            onInput={(e) => setGlobalFilter(e.target.value)}
            placeholder="Search..."
          />
        </span>
      </div>
    );
  };

  const rightToolbarTemplate = () => {
    return (
      <div className="d-flex flex-wrap gap-2">
        <Button
          label="New"
          icon="pi pi-plus"
          severity="success"
          onClick={openNew}
        />
        <Button
          label="Export"
          icon="pi pi-upload"
          className="p-button-help"
          onClick={exportCSV}
        />
        <Button
          label="Delete"
          icon="pi pi-trash"
          severity="danger"
          onClick={confirmDeleteSelected}
          disabled={
            !selectedProjectListContents || !selectedProjectListContents.length
          }
        />
      </div>
    );
  };
  const actionBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-pencil"
          rounded
          outlined
          style={{ marginRight: "10px" }}
          onClick={() => editProduct(rowData)}
        />
        <Button
          icon="pi pi-trash"
          rounded
          outlined
          severity="danger"
          onClick={() => confirmDeleteProduct(rowData)}
        />
      </React.Fragment>
    );
  };
  const header = (
    <div className="d-flex flex-wrap gap-2 align-items-center justify-content-between">
      {/* <h4 className="m-0">Manage Project Icons</h4>
      <span className="p-input-icon-left">
        <i className="pi pi-search" />
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
        />
      </span> */}
    </div>
  );
  const productDialogFooter = (
    <React.Fragment>
      <Button
        label="Cancel"
        icon="pi pi-times"
        outlined
        style={{ borderRadius: "10px" }}
        onClick={hideDialog}
      />
      <Button
        label="Save"
        loading={loading}
        style={{ borderRadius: "10px" }}
        icon="pi pi-check"
        onClick={saveService}
      />
    </React.Fragment>
  );
  const deleteProductDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteProduct}
      />
    </React.Fragment>
  );
  const deleteProductsDialogFooter = (
    <React.Fragment>
      <Button
        label="No"
        icon="pi pi-times"
        outlined
        onClick={hideDeleteProductsDialog}
      />
      <Button
        label="Yes"
        loading={loading}
        icon="pi pi-check"
        severity="danger"
        onClick={deleteSelectedProducts}
      />
    </React.Fragment>
  );

  return (
    <div className="col-12 d-flex">
      <div className="col-3">
        <DashSideBar />
      </div>
      <div className="col-9">
        <div className="ProjectListContent-container">
          <Toast ref={toast} />
          <div className="card">
            <Toolbar
              className="mb-3"
              start={leftToolbarTemplate}
              end={rightToolbarTemplate}
            ></Toolbar>

            <DataTable
              ref={dt}
              value={ProjectListContents}
              selection={selectedProjectListContents}
              onSelectionChange={(e) => setSelectedProjectListContents(e.value)}
              dataKey="id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Project Icons"
              globalFilter={globalFilter}
              header={header}
            >
              <Column selectionMode="multiple" exportable={false}></Column>
              <Column
                field="id"
                header="Code"
                sortable
                width="150px"
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                field="name"
                header="Name"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>
              <Column
                field="project.name"
                header="Project"
                sortable
                style={{ minWidth: "12rem" }}
              ></Column>

              <Column
                field="sortOrder"
                header="Order"
                sortable
                style={{ textAlign: "center" }}
              ></Column>

              <Column
                body={actionBodyTemplate}
                exportable={false}
                style={{ minWidth: "12rem" }}
              ></Column>
            </DataTable>
          </div>

          <Dialog
            visible={ProjectListContentsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="ProjectListContent Details"
            modal
            className="p-fluid"
            footer={productDialogFooter}
            onHide={hideDialog}
          >
            <div className="field">
              <label htmlFor="name" className="font-bold mb-1">
                Name :
              </label>
              <InputText
                id="name"
                value={ProjectListContent.name}
                onChange={(e) => onInputChange(e, "name")}
                required
                className={classNames({
                  "p-invalid": submitted && !ProjectListContent.name,
                })}
              />
              {submitted && !ProjectListContent.name && (
                <small className="p-error">Name is required.</small>
              )}
            </div>
            <div className="field">
              <label htmlFor="description" className="font-bold mb-1">
                Description :
              </label>
              <Editor
                id="description"
                value={ProjectListContent.description}
                style={{ height: "100px" }}
                onTextChange={(e) =>
                  onInputChange(
                    { target: { value: e.htmlValue } },
                    "description"
                  )
                }
                required
                className={classNames({
                  "p-invalid": submitted && !ProjectListContent.description,
                })}
              />
            </div>
            <div className="field">
              <label className="mb-3 font-bold">Porject</label>
              {projects != null ? (
                <Dropdown
                  value={ProjectListContent.project.id}
                  options={projects.map((project) => ({
                    value: project.id,
                    label: project.name,
                  }))}
                  onChange={onProjectChange}
                  placeholder="Select a Project"
                />
              ) : (
                <p>Loading projects...</p>
              )}
            </div>
            <div className="field">
              <label htmlFor="sortOrder" className="font-bold mt-3 mb-1">
                Order :
              </label>
              <InputText
                id="sortOrder"
                type="number"
                value={ProjectListContent.sortOrder}
                onChange={(e) => onInputChange(e, "sortOrder")}
                required
                className={classNames({
                  "p-invalid": submitted && !ProjectListContent.sortOrder,
                })}
              />
              {submitted && !ProjectListContent.sortOrder && (
                <small className="p-error">Sort Order is required.</small>
              )}
            </div>
          </Dialog>

          <Dialog
            visible={DeleteProjectListContent}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductDialogFooter}
            onHide={hideDeleteProductDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              <div>
                <p style={{ textAlign: "center", marginBottom: "5px" }}>
                  Are you sure you want to delete:
                </p>
                {ProjectListContent && (
                  <p style={{ textAlign: "center", marginBottom: "0" }}>
                    <b>{ProjectListContent.title}</b>
                  </p>
                )}
              </div>
            </div>
          </Dialog>

          <Dialog
            visible={DeleteProjectListContentsDialog}
            style={{ width: "32rem" }}
            breakpoints={{ "960px": "75vw", "641px": "90vw" }}
            header="Confirm"
            modal
            footer={deleteProductsDialogFooter}
            onHide={hideDeleteProductsDialog}
          >
            <div className="confirmation-content">
              <i
                className="pi pi-exclamation-triangle mr-3"
                style={{
                  textAlign: "center",
                  fontSize: "2rem",
                  width: "100%",
                  color: "#6659ff",
                }}
              />
              {ProjectListContent && (
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    marginBottom: "25px",
                  }}
                >
                  Are you sure you want to delete the selected Project List
                  Contents?
                </p>
              )}
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}

export default ProjectListContents;
